import React, { useEffect, useState, useRef } from 'react';
import axios, { formToJSON } from 'axios';
import { useParams } from 'react-router-dom';
import $, { data } from 'jquery';
import 'select2';
import '../css/Select2.css';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import '../css/new.css';
import reloadToken from '../helper/reloadtoken';
import helperFilter from '../helper/helperfilter';
import HeaderMenu from '../template/HeaderMenu';
import { apiConfig } from '../helper/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {utils, writeFile} from 'xlsx';

const mainhost = process.env.REACT_APP_API_URL_ONLINE;

const API_AssetReportIdrUSD = mainhost + "report_idr_usd/r_idr_usd"
const API_AssetReportUSD = mainhost + "report_idr_usd/r_usd"


const currentUrl = window.location.href;

const notify_cant_update_br_cont = (message, time = 800) => {
  toast.error(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const notify_update_br_cont = (message, time = 2000) => {
  toast.success(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const ReportIdrUSD = () => {
  const token = localStorage.getItem('token');

  const [TokenNew, setToken] = useState(null);
  const [ReportIdrUsd, setReportIdrUsd] = useState(null);
  const [ReportUsd, setReportUsd] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const config = apiConfig(token);
  const tableDataInOut = useRef(null);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);
  const current_month = new Date().getMonth() + 1;

  const selectForBln = useRef(null);
  const selectForYearh = useRef(null);

  const year_local = localStorage.getItem("year_selected");
  const month_local = localStorage.getItem("month_selected");

  const year_selected = year_local ?  parseInt(year_local) : years[0]
  const month_selected = month_local ? parseInt(month_local) : current_month

  const [selectedYear, setSelectedYear] = useState(year_selected);
  const [selectedMonth, setSelectedMonth] = useState(month_selected);

  const months = [
    { value: '1', label: 'Januari' },
    { value: '2', label: 'Februari' },
    { value: '3', label: 'Maret' },
    { value: '4', label: 'April' },
    { value: '5', label: 'Mei' },
    { value: '6', label: 'Juni' },
    { value: '7', label: 'Juli' },
    { value: '8', label: 'Agustus' },
    { value: '9', label: 'September' },
    { value: '10', label: 'Oktober' },
    { value: '11', label: 'November' },
    { value: '12', label: 'Desember' },
  ];
  
  const getReportIdrUsd = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportIdrUSD}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportUsd = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportUSD}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleChange = () => {

  }

  const handleMonthChange = (event) => {
    const value = event.target.value;
    let intValue;
    if (value.trim() !== '') {
         intValue = parseInt(value, 10);
        if (!isNaN(intValue)) {
        } else {
          intValue="";
        }
    } else {
      intValue="";
    }
    setSelectedMonth(intValue);
    localStorage.setItem("month_selected", intValue);
    window.location.reload();
  }

  const handleSelectYearChange = (year) => {
    const value = year.target.value;
    let intValue = parseInt(value, 10);
    if (!isNaN(intValue)) {
      setSelectedYear(intValue); // Update selected year state
      localStorage.setItem("year_selected", intValue); // Store in local storage
    } else {
      setSelectedYear(""); // Reset selected year state
      localStorage.removeItem("year_selected"); // Remove from local storage
    }
    window.location.reload();
  }


  $(selectForBln.current).on('change', handleMonthChange);
  $(selectForYearh.current).on('change', handleSelectYearChange);

  useEffect(() => {
    setIsLoading(true);
    //TYPE
    $('.js-example-basic-single').select2();
    $('.js-example-basic-multiple').select2({
      theme: "classic"
    });

    const getIdFromUrl = () => {
      const urlParts = window.location.href.split('/');
      const id = urlParts[urlParts.length - 1];
      return id;
    };
    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const newToken = await reloadToken();
      setToken(newToken);
      const sum_IdrUsd = await getReportIdrUsd();
      setReportIdrUsd(sum_IdrUsd);
      const sum_Usd = await getReportUsd();
      setReportUsd(sum_Usd);
      
      setIsLoading(false);
    };

    new Promise((resolve) => setTimeout(resolve, 100));

    function isMobileDevice() {
      const mobileScreenWidth = 768;
      return window.innerWidth < mobileScreenWidth;
    }

    setTimeout(function () {
      var calcChainLength = 0;

    }, 1500);

    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    } else {
      // If token is not found in localStorage, reload it
      reloadToken().then(newToken => {
        setToken(newToken);
        // Store the token in localStorage for future use
        localStorage.setItem('token', newToken);
      });
    }

    fetchData();
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Tab is hidden');
        // luckysheet.refresh();
      } else {
        console.log('Tab is visible');
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      // clearInterval(intervalId);

      $(selectForBln.current).on('change', handleMonthChange);
      $(selectForYearh.current).on('change', handleSelectYearChange);
    };
  }, []);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const formatNumberWithoutDecimals = (num) => {
    // convert num into float
    num = parseFloat(num);
    if (isNaN(num)) {
      return '0';
    }
    return num.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };
  const selectStyle120 = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '120px',
    height: '10%',
    marginTop: '5px',
  };
  const labelStyel = {
    marginTop: '22px',
  };
  const randomKey = () => {
    return Math.random().toString(36).substr(2, 9);
  }
  const remove_dot = (dataRow) => {
    for (let i = 0; i < dataRow.length; i++) {
      if (typeof dataRow[i] === "undefined") {
        continue;
      }
      for (let j = 0; j < dataRow[i].length; j++) {
        if (typeof dataRow[i][j] === "undefined") {
          continue;
        }
        // try convert to float
        dataRow[i][j] = dataRow[i][j].replace(/\./g, '');
        if (parseFloat(dataRow[i][j]) >= 0) {
          dataRow[i][j] = parseFloat(dataRow[i][j]);
        }
      }
    }
    return dataRow;
  }
  return (
    <div>
      <HeaderMenu title={"Report All Divisi"} subtitle={"Report All Divis"} />
      {/* <ToastContainer /> */}
      
      <div style={{ textAlign: 'center' }}>
        <table border={0}>
          <thead>
          </thead>
          <tbody>
            <tr>
              <td>
                <select style={selectStyle120} ref={selectForBln} className="js-example-basic-single style-select-report" value={selectedMonth || ""} onChange={handleChange}>
                <option value="">-PILIH-</option>
                  {months.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              </td>
              <td>
              <select style={selectStyle120} ref={selectForYearh} className="js-example-basic-single style-select-report" value={selectedYear} onChange={handleChange}>
                  <option value="">-PILIH-</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </td>  
            </tr>
          </tbody>
        </table>

      </div>
      <div className="containers" style={{ width : "100%"}}>
        <div style={{ textAlign: 'center', overflow:'auto', height:'80vh', width:'100%'}}>
          <h2>IDR</h2>
          <table ref={tableDataInOut} className='table table-bordered' style={{ width:'600px'}}>
            <thead>
            <tr>
              <th rowSpan="2">Asset</th>
              {ReportIdrUsd && ReportIdrUsd["divisi"] && Object.keys(ReportIdrUsd["divisi"]).length > 0 ? (
                <>
                  <th colSpan={Object.keys(ReportIdrUsd["divisi"]).length + 1}>Expense</th>
                  <th colSpan={Object.keys(ReportIdrUsd["divisi"]).length + 1}>Salary</th>
                  <th colSpan={Object.keys(ReportIdrUsd["divisi"]).length + 1}>Kasbon</th>
                </>
              ) : (
                <th colSpan="4" style={{ textAlign: 'center', fontStyle: 'italic' }}>Loading...</th>
              )}
              <th rowSpan="2" style={{ fontWeight: 'bold' }}>Total</th>
            </tr>
            <tr>
              <th>-</th>
              {ReportIdrUsd && ReportIdrUsd["divisi"] && Object.keys(ReportIdrUsd["divisi"]).length > 0 ? (
                Object.keys(ReportIdrUsd["divisi"]).map((item2, index2) => (
                  <th key={index2} style={{ textAlign: 'right', width: '240px' }}>
                    {ReportIdrUsd["divisi"][item2]} {/* Use key name as header */}
                  </th>
                ))
              ) : (
                <th colSpan="3" style={{ textAlign: 'center', fontStyle: 'italic' }}>Loading...</th>
              )}
              <th>-</th>
              {ReportIdrUsd && ReportIdrUsd["divisi"] && Object.keys(ReportIdrUsd["divisi"]).length > 0 ? (
                Object.keys(ReportIdrUsd["divisi"]).map((item2, index2) => (
                  <th key={index2} style={{ textAlign: 'right', width: '240px' }}>
                    {ReportIdrUsd["divisi"][item2]} {/* Use key name as header */}
                  </th>
                ))
              ) : (
                <th colSpan="3" style={{ textAlign: 'center', fontStyle: 'italic' }}>Loading...</th>
              )}
              <th>-</th>
              {ReportIdrUsd && ReportIdrUsd["divisi"] && Object.keys(ReportIdrUsd["divisi"]).length > 0 ? (
                Object.keys(ReportIdrUsd["divisi"]).map((item2, index2) => (
                  <th key={index2} style={{ textAlign: 'right', width: '240px' }}>
                    {ReportIdrUsd["divisi"][item2]} {/* Use key name as header */}
                  </th>
                ))
              ) : (
                <th colSpan="3" style={{ textAlign: 'center', fontStyle: 'italic' }}>Loading...</th>
              )}
            </tr>

            </thead>
            <tbody>
            { isLoading ? <tr><td>Loading...</td></tr> :
            Object.keys(ReportIdrUsd["asset"]).map((item,index) => (
              <tr key={index}  style={item === "Total" ? { backgroundColor: "yellow" } : null}>
                <td style={{ textAlign:'left', width:'240px'}}>{ReportIdrUsd["asset"][item]}</td> 
                {/* Expense */}
                <td>
                {ReportIdrUsd && ReportIdrUsd["expend"] && ReportIdrUsd["expend"][""] && ReportIdrUsd["expend"][""][ReportIdrUsd["asset"][item]] ? (
                  formatNumberWithoutDecimals(ReportIdrUsd["expend"][""][ReportIdrUsd["asset"][item]])
                ) : (
                  "0"
                )
                }
                </td>
                {Object.keys(ReportIdrUsd["divisi"]).map((item2,index2) => (
                  <td key={index2} style={{ textAlign:'right', width:'240px'}}>
                    {formatNumberWithoutDecimals(ReportIdrUsd["expend"][ReportIdrUsd["divisi"][item2]][ReportIdrUsd["asset"][item]])}
                  </td>
                ))
                }

                {/* Salary  */}
                <td>
                {ReportIdrUsd && ReportIdrUsd["salary"] && ReportIdrUsd["salary"][""] && ReportIdrUsd["salary"][""][ReportIdrUsd["asset"][item]] ? (
                  formatNumberWithoutDecimals(ReportIdrUsd["salary"][""][ReportIdrUsd["asset"][item]])
                ) : (
                  "0"
                )
                }
                </td>
                {ReportIdrUsd && ReportIdrUsd["salary"] ? (
                      Object.keys(ReportIdrUsd["divisi"]).map((item2,index2) => (
                      <td key={index2} style={{ textAlign:'right', width:'240px'}}>
                        {ReportIdrUsd && ReportIdrUsd["salary"] && ReportIdrUsd["salary"][ReportIdrUsd["divisi"][item2]] && ReportIdrUsd["salary"][ReportIdrUsd["divisi"][item2]][ReportIdrUsd["asset"][item]] ? (
                          formatNumberWithoutDecimals(ReportIdrUsd["salary"][ReportIdrUsd["divisi"][item2]][ReportIdrUsd["asset"][item]])
                        ) : (
                          "0"
                        )}
                      </td>
                    ))
                  ) : (
                    <td>0</td>
                  )
                }
                
                {/* Kasbon */}
                <td>
                {ReportIdrUsd && ReportIdrUsd["kasbon"] && ReportIdrUsd["kasbon"][""] && ReportIdrUsd["kasbon"][""][ReportIdrUsd["asset"][item]] ? (
                  formatNumberWithoutDecimals(ReportIdrUsd["kasbon"][""][ReportIdrUsd["asset"][item]])
                ) : (
                  "0"
                )
                }
                </td>
                {ReportIdrUsd && ReportIdrUsd["kasbon"] ? (
                      Object.keys(ReportIdrUsd["divisi"]).map((item2,index2) => (
                      <td key={index2} style={{ textAlign:'right', width:'240px'}}>
                        {ReportIdrUsd && ReportIdrUsd["kasbon"] && ReportIdrUsd["kasbon"][ReportIdrUsd["divisi"][item2]] && ReportIdrUsd["kasbon"][ReportIdrUsd["divisi"][item2]][ReportIdrUsd["asset"][item]] ? (
                          formatNumberWithoutDecimals(ReportIdrUsd["kasbon"][ReportIdrUsd["divisi"][item2]][ReportIdrUsd["asset"][item]])
                        ) : (
                          "0"
                        )}
                      </td>
                    ))
                  ) : (
                    <td>0</td>
                  )
                }
                {ReportIdrUsd && ReportIdrUsd["total"] ? (
                      <td key={index} style={{ textAlign:'right', width:'240px'}}>
                        {ReportIdrUsd && ReportIdrUsd["total"] && ReportIdrUsd["total"] && ReportIdrUsd["total"][ReportIdrUsd["asset"][item]] ? (
                          formatNumberWithoutDecimals(ReportIdrUsd["total"][ReportIdrUsd["asset"][item]])
                        ) : (
                          "0"
                        )}
                      </td>
                  ) : (
                    <td>0</td>
                  )
                }
              </tr>
            ))
            }
  {ReportIdrUsd && ReportIdrUsd["total"] ? (
  <tr style={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}>
    <th>Total</th>

    {/* ✅ Total Expense */}
    <td style={{ textAlign: "right", width: "240px" }}>
      {formatNumberWithoutDecimals(
        Object.keys(ReportIdrUsd["asset"] || {}).reduce((sum, item) => {
          const value = ReportIdrUsd["expend"]?.[""]?.[ReportIdrUsd["asset"][item]];
          return sum + (value ? Number(value) : 0);
        }, 0)
      )}
    </td>
    {Object.keys(ReportIdrUsd["divisi"] || {}).map((item2, index2) => (
      <td key={index2} style={{ textAlign: "right", width: "240px" }}>
        {formatNumberWithoutDecimals(
          Object.keys(ReportIdrUsd["asset"] || {}).reduce((sum, item) => {
            const value = ReportIdrUsd["expend"]?.[ReportIdrUsd["divisi"][item2]]?.[ReportIdrUsd["asset"][item]];
            return sum + (value ? Number(value) : 0);
          }, 0)
        )}
      </td>
    ))}

    {/* ✅ Total Salary */}
    <td style={{ textAlign: "right", width: "240px" }}>
      {formatNumberWithoutDecimals(
        Object.keys(ReportIdrUsd["asset"] || {}).reduce((sum, item) => {
          const value = ReportIdrUsd["salary"]?.[""]?.[ReportIdrUsd["asset"][item]];
          return sum + (value ? Number(value) : 0);
        }, 0)
      )}
    </td>
    {Object.keys(ReportIdrUsd["divisi"] || {}).map((item2, index2) => (
      <td key={index2} style={{ textAlign: "right", width: "240px" }}>
        {formatNumberWithoutDecimals(
          Object.keys(ReportIdrUsd["asset"] || {}).reduce((sum, item) => {
            const value = ReportIdrUsd["salary"]?.[ReportIdrUsd["divisi"][item2]]?.[ReportIdrUsd["asset"][item]];
            return sum + (value ? Number(value) : 0);
          }, 0)
        )}
      </td>
    ))}

    {/* ✅ Total Kasbon */}
    <td style={{ textAlign: "right", width: "240px" }}>
      {formatNumberWithoutDecimals(
        Object.keys(ReportIdrUsd["asset"] || {}).reduce((sum, item) => {
          const value = ReportIdrUsd["kasbon"]?.[""]?.[ReportIdrUsd["asset"][item]];
          return sum + (value ? Number(value) : 0);
        }, 0)
      )}
    </td>
    {Object.keys(ReportIdrUsd["divisi"] || {}).map((item2, index2) => (
      <td key={index2} style={{ textAlign: "right", width: "240px" }}>
        {formatNumberWithoutDecimals(
          Object.keys(ReportIdrUsd["asset"] || {}).reduce((sum, item) => {
            const value = ReportIdrUsd["kasbon"]?.[ReportIdrUsd["divisi"][item2]]?.[ReportIdrUsd["asset"][item]];
            return sum + (value ? Number(value) : 0);
          }, 0)
        )}
      </td>
    ))}

    {/* ✅ Grand Total */}
    <td style={{ textAlign: "right", width: "240px", fontWeight: "bold" }}>
      {formatNumberWithoutDecimals(
        Object.keys(ReportIdrUsd["asset"] || {}).reduce((sum, item) => {
          const value = ReportIdrUsd["total"]?.[ReportIdrUsd["asset"][item]];
          return sum + (value ? Number(value) : 0);
        }, 0)
      )}
    </td>
  </tr>
) : (
  <tr>
    <td colSpan="4" style={{ textAlign: "center" }}>Loading...</td>
  </tr>
)}

          </tbody>
            
          </table>
          <h2>USD</h2>
          <table ref={tableDataInOut} className='table table-bordered' style={{ width:'600px'}}>
            <thead>
            <tr>
              <th rowSpan="2">Asset</th>
              {ReportUsd && ReportUsd["divisi"] && Object.keys(ReportUsd["divisi"]).length > 0 ? (
                <>
                  <th colSpan={Object.keys(ReportUsd["divisi"]).length + 1}>Expense</th>
                  <th colSpan={Object.keys(ReportUsd["divisi"]).length + 1}>Salary</th>
                  <th colSpan={Object.keys(ReportUsd["divisi"]).length + 1}>Kasbon</th>
                </>
              ) : (
                <th colSpan="4" style={{ textAlign: 'center', fontStyle: 'italic' }}>Loading...</th>
              )}
              <th rowSpan="2" style={{ fontWeight: 'bold' }}>Total</th>
            </tr>
            <tr>
              <th>-</th>
              {ReportUsd && ReportUsd["divisi"] && Object.keys(ReportUsd["divisi"]).length > 0 ? (
                Object.keys(ReportUsd["divisi"]).map((item2, index2) => (
                  <th key={index2} style={{ textAlign: 'right', width: '240px' }}>
                    {ReportUsd["divisi"][item2]} {/* Use key name as header */}
                  </th>
                ))
              ) : (
                <th colSpan="3" style={{ textAlign: 'center', fontStyle: 'italic' }}>Loading...</th>
              )}
              <th>-</th>
              {ReportUsd && ReportUsd["divisi"] && Object.keys(ReportUsd["divisi"]).length > 0 ? (
                Object.keys(ReportUsd["divisi"]).map((item2, index2) => (
                  <th key={index2} style={{ textAlign: 'right', width: '240px' }}>
                    {ReportUsd["divisi"][item2]} {/* Use key name as header */}
                  </th>
                ))
              ) : (
                <th colSpan="3" style={{ textAlign: 'center', fontStyle: 'italic' }}>Loading...</th>
              )}
              <th>-</th>
              {ReportUsd && ReportUsd["divisi"] && Object.keys(ReportUsd["divisi"]).length > 0 ? (
                Object.keys(ReportUsd["divisi"]).map((item2, index2) => (
                  <th key={index2} style={{ textAlign: 'right', width: '240px' }}>
                    {ReportUsd["divisi"][item2]} {/* Use key name as header */}
                  </th>
                ))
              ) : (
                <th colSpan="3" style={{ textAlign: 'center', fontStyle: 'italic' }}>Loading...</th>
              )}
            </tr>

            </thead>
            <tbody>
            { isLoading ? <tr><td>Loading...</td></tr> :
            Object.keys(ReportUsd["asset"]).map((item,index) => (
              <tr key={index}  style={item === "Total" ? { backgroundColor: "yellow" } : null}>
                <td style={{ textAlign:'left', width:'240px'}}>{ReportUsd["asset"][item]}</td> 
                {/* Expense */}
                <td>
                {ReportUsd && ReportUsd["expend"] && ReportUsd["expend"][""] && ReportUsd["expend"][""][ReportUsd["asset"][item]] ? (
                  formatNumberWithoutDecimals(ReportUsd["expend"][""][ReportUsd["asset"][item]])
                ) : (
                  "0"
                )
                }
                </td>
                {Object.keys(ReportUsd["divisi"]).map((item2,index2) => (
                  <td key={index2} style={{ textAlign:'right', width:'240px'}}>
                    {formatNumberWithoutDecimals(ReportUsd["expend"][ReportUsd["divisi"][item2]][ReportUsd["asset"][item]])}
                  </td>
                ))
                }

                {/* Salary  */}
                <td>
                {ReportUsd && ReportUsd["salary"] && ReportUsd["salary"][""] && ReportUsd["salary"][""][ReportUsd["asset"][item]] ? (
                  formatNumberWithoutDecimals(ReportUsd["salary"][""][ReportUsd["asset"][item]])
                ) : (
                  "0"
                )
                }
                </td>
                {ReportUsd && ReportUsd["salary"] ? (
                      Object.keys(ReportUsd["divisi"]).map((item2,index2) => (
                      <td key={index2} style={{ textAlign:'right', width:'240px'}}>
                        {ReportUsd && ReportUsd["salary"] && ReportUsd["salary"][ReportUsd["divisi"][item2]] && ReportUsd["salary"][ReportUsd["divisi"][item2]][ReportUsd["asset"][item]] ? (
                          formatNumberWithoutDecimals(ReportUsd["salary"][ReportUsd["divisi"][item2]][ReportUsd["asset"][item]])
                        ) : (
                          "0"
                        )}
                      </td>
                    ))
                  ) : (
                    <td>0</td>
                  )
                }
                
                {/* Kasbon */}
                <td>
                {ReportUsd && ReportUsd["kasbon"] && ReportUsd["kasbon"][""] && ReportUsd["kasbon"][""][ReportUsd["asset"][item]] ? (
                  formatNumberWithoutDecimals(ReportUsd["kasbon"][""][ReportUsd["asset"][item]])
                ) : (
                  "0"
                )
                }
                </td>
                {ReportUsd && ReportUsd["kasbon"] ? (
                      Object.keys(ReportUsd["divisi"]).map((item2,index2) => (
                      <td key={index2} style={{ textAlign:'right', width:'240px'}}>
                        {ReportUsd && ReportUsd["kasbon"] && ReportUsd["kasbon"][ReportUsd["divisi"][item2]] && ReportUsd["kasbon"][ReportUsd["divisi"][item2]][ReportUsd["asset"][item]] ? (
                          formatNumberWithoutDecimals(ReportUsd["kasbon"][ReportUsd["divisi"][item2]][ReportUsd["asset"][item]])
                        ) : (
                          "0"
                        )}
                      </td>
                    ))
                  ) : (
                    <td>0</td>
                  )
                }
                {ReportUsd && ReportUsd["total"] ? (
                      <td key={index} style={{ textAlign:'right', width:'240px'}}>
                        {ReportUsd && ReportUsd["total"] && ReportUsd["total"] && ReportUsd["total"][ReportUsd["asset"][item]] ? (
                          formatNumberWithoutDecimals(ReportUsd["total"][ReportUsd["asset"][item]])
                        ) : (
                          "0"
                        )}
                      </td>
                  ) : (
                    <td>0</td>
                  )
                }
              </tr>
            ))
            }
  {ReportUsd && ReportUsd["total"] ? (
  <tr style={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}>
    <th>Total</th>

    {/* ✅ Total Expense */}
    <td style={{ textAlign: "right", width: "240px" }}>
      {formatNumberWithoutDecimals(
        Object.keys(ReportUsd["asset"] || {}).reduce((sum, item) => {
          const value = ReportUsd["expend"]?.[""]?.[ReportUsd["asset"][item]];
          return sum + (value ? Number(value) : 0);
        }, 0)
      )}
    </td>
    {Object.keys(ReportUsd["divisi"] || {}).map((item2, index2) => (
      <td key={index2} style={{ textAlign: "right", width: "240px" }}>
        {formatNumberWithoutDecimals(
          Object.keys(ReportUsd["asset"] || {}).reduce((sum, item) => {
            const value = ReportUsd["expend"]?.[ReportUsd["divisi"][item2]]?.[ReportUsd["asset"][item]];
            return sum + (value ? Number(value) : 0);
          }, 0)
        )}
      </td>
    ))}

    {/* ✅ Total Salary */}
    <td style={{ textAlign: "right", width: "240px" }}>
      {formatNumberWithoutDecimals(
        Object.keys(ReportUsd["asset"] || {}).reduce((sum, item) => {
          const value = ReportUsd["salary"]?.[""]?.[ReportUsd["asset"][item]];
          return sum + (value ? Number(value) : 0);
        }, 0)
      )}
    </td>
    {Object.keys(ReportUsd["divisi"] || {}).map((item2, index2) => (
      <td key={index2} style={{ textAlign: "right", width: "240px" }}>
        {formatNumberWithoutDecimals(
          Object.keys(ReportUsd["asset"] || {}).reduce((sum, item) => {
            const value = ReportUsd["salary"]?.[ReportUsd["divisi"][item2]]?.[ReportUsd["asset"][item]];
            return sum + (value ? Number(value) : 0);
          }, 0)
        )}
      </td>
    ))}

    {/* ✅ Total Kasbon */}
    <td style={{ textAlign: "right", width: "240px" }}>
      {formatNumberWithoutDecimals(
        Object.keys(ReportUsd["asset"] || {}).reduce((sum, item) => {
          const value = ReportUsd["kasbon"]?.[""]?.[ReportUsd["asset"][item]];
          return sum + (value ? Number(value) : 0);
        }, 0)
      )}
    </td>
    {Object.keys(ReportUsd["divisi"] || {}).map((item2, index2) => (
      <td key={index2} style={{ textAlign: "right", width: "240px" }}>
        {formatNumberWithoutDecimals(
          Object.keys(ReportUsd["asset"] || {}).reduce((sum, item) => {
            const value = ReportUsd["kasbon"]?.[ReportUsd["divisi"][item2]]?.[ReportUsd["asset"][item]];
            return sum + (value ? Number(value) : 0);
          }, 0)
        )}
      </td>
    ))}

    {/* ✅ Grand Total */}
    <td style={{ textAlign: "right", width: "240px", fontWeight: "bold" }}>
      {formatNumberWithoutDecimals(
        Object.keys(ReportUsd["asset"] || {}).reduce((sum, item) => {
          const value = ReportUsd["total"]?.[ReportUsd["asset"][item]];
          return sum + (value ? Number(value) : 0);
        }, 0)
      )}
    </td>
  </tr>
) : (
  <tr>
    <td colSpan="4" style={{ textAlign: "center" }}>Loading...</td>
  </tr>
)}

          </tbody>
            
          </table>
        </div>
      </div>
    </div>
    
  );
};


export default ReportIdrUSD;